import Immutable from 'immutable';
import {
  SET_FEED_FOR_BLOCK,
  SET_BLOCK_FEED_DATA,
  APPEND_BLOCK_FEED_DATA,
  PREPEND_BLOCK_FEED_DATA,
  FEED_DATA_REFRESH_START,
  FEED_DATA_LOAD_MORE_START,
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
  FEED_DATA_FETCH_FAILED,
} from './actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';

const BY_BLOCK_ID = 'byBlockId';
const PAGES_BY_PATH = 'pagesByPath';

const DEFAULT_STATE = Immutable.fromJS({
  [BY_BLOCK_ID]: {},
  [PAGES_BY_PATH]: {},
});

export function Feeds(state = DEFAULT_STATE, action) {
  const setFeedFetchingStatus = (type, status) => {
    const path = ['feed', type];
    let newState = state;
    newState = state.setIn(path, status);
    newState = newState.setIn(
      ['byCohortPath', action.cohortPath],
      Immutable.fromJS(action.feed)
    );
    return newState;
  };

  switch (action.type) {
    case FEED_DATA_REFRESH_START:
      return setFeedFetchingStatus('refresh', true);
    case FEED_DATA_LOAD_MORE_START:
      return setFeedFetchingStatus('loadMore', true);
    case APPEND_BLOCK_FEED_DATA:
    case PREPEND_BLOCK_FEED_DATA:
    case SET_BLOCK_FEED_DATA:
    case SET_FEED_FOR_BLOCK: {
      // Update the feed information
      let newState = state.setIn(
        [BY_BLOCK_ID, action.blockID],
        Immutable.fromJS(action.feed)
      );

      // Update the pages used in the feed display
      if (action.pages) {
        action.pages.forEach((page) => {
          newState = newState.setIn(
            [PAGES_BY_PATH, page.path],
            Immutable.fromJS(page)
          );
        });
      }

      return newState;
    }
    case FEED_DATA_FETCH_SUCCESS:
      return setFeedFetchingStatus('fetch', false);
    case FEED_DATA_REFRESH_SUCCESS:
      return setFeedFetchingStatus('refresh', false);
    case FEED_DATA_LOAD_MORE_SUCCESS: {
      return setFeedFetchingStatus('loadMore', false);
    }
    case FEED_DATA_FETCH_FAILED: {
      let newState = state;
      newState = setFeedFetchingStatus('fetch', false);
      newState = setFeedFetchingStatus('refresh', false);
      newState = setFeedFetchingStatus('loadMore', false);
      return newState;
    }
    case LOGOUT_SUCCESS: {
      return DEFAULT_STATE;
    }
    default: {
      return state;
    }
  }
}
